export default {
  title: 'Atualizações',
  fields: {
    app_version: 'Versão da App',
    description: 'Descrição',
    created_at: 'Criado em',
  },
};
